<h1 mat-dialog-title i18n="Import Users|Import Users title@@import-users-title">Import Users</h1>
<div mat-dialog-content #dialogContent class="dialog-content">
  <permission-checker [roles]="roles">
    <school-details *ngIf="school && !importResult"
                    [school]="school"
                    [compact]="true"
                    [fullDetails]="false"></school-details>

    <form *ngIf="school && region && !importResult" [formGroup]="importForm">
      <form-input [control]="roleField"
                  label="Role"
                  i18n-label="Invite User Modal|Invite User Modal role input label@@invite-user-modal-role-input-label"
                  [options]="userRoles"
                  [compareWith]="compareRoles"
                  [displayWith]="displayRole"></form-input>

      <file-upload acceptTypes=".csv"
                   fileTypes="*.csv"
                   (fileSelected)="onFileSelected($event)">
      </file-upload>

      <mat-divider class="full-width sections-divider"></mat-divider>

      <div class="center-align text-disabled-color mat-body-2"
           i18n="Import Users|Import Users file details description@@import-users-file-details-description">
        Users will be imported from the selected CSV file to the chosen school. The file should contain the user's name,
        grade, and email (can be omitted in some cases). An example of a file can be found below (file should contain a
        header row):
      </div>

      <div class="center-align">
        <a class="primary-color" [href]="exampleFileUrl" target="_blank"
           i18n="Import Users|Import Users file url title@@import-users-file-url-title">example file</a>
      </div>
    </form>

    <div *ngIf="importResult" class="import-result-container">
      <div *ngIf="importResult?.users?.length" class="color-green body-2">
        <p>
          <ng-container i18n="Import Users|Import Users success description@@import-users-success-description">Successfully imported users</ng-container>: {{importResult.users?.length}}
        </p>
      </div>
      <div *ngIf="hasImportIssues">
        <p i18n="Import Users|Import Users issues description@@import-users-issues-description"
           class="color-warn">Users import issues:</p>

        <div *ngFor="let issue of importResult.issues | keyvalue" class="import-issue-container full-width">
          <div class="import-issue full-width">
            <div>{{localizeImportIssue(issue.key)}}</div>
            <div class="fill-space"></div>
            <div>
              <mat-icon *ngIf="issue.value"
                        (click)="downloadFile(issue.value, issue.key)"
                        class="btn"
                        matTooltip="Download"
                        i18n-matTooltip="General|Download action label@@general-download-action-label">file_download</mat-icon>
            </div>
          </div>
          <div class="full-width">
            <users-table [users]="issue.value"
                         [showActions]="false"
                         [showGrade]="true"></users-table>
          </div>
        </div>
      </div>
    </div>
  </permission-checker>
</div>
<div mat-dialog-actions>
  <div *ngIf="!importResult">
    <app-button [disabled]="inProgress"
                (clicked)="closeModal()"
                [secondary]="true"
                label="Cancel"
                i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>
    <span class="btn-spacer"></span>
    <app-button [disabled]="inProgress || !proceedAllowed()"
                (clicked)="proceed()"
                label="Import"
                i18n-label="General|Import action label@@general-import-action-label"></app-button>
  </div>
  <div *ngIf="importResult">
    <app-button [disabled]="inProgress"
                (clicked)="closeModal(importResult.users)"
                [secondary]="true"
                label="Close"
                i18n-label="General|Close action label@@general-close-action-label"></app-button>
  </div>
</div>
